import get from '../accessors/get';

export default function resolveStringValue(target: string | Record<string, string> | boolean | null | unknown, key?: string | string[]): string {
  if (target === null || typeof target === 'undefined' || target === '') {
    return '__NULL__';
  }

  if (typeof target !== 'object') {
    return String(target);
  }

  if (typeof key === 'string') {
    return resolveStringValue(get(target, key));
  }

  if (Array.isArray(key)) {
    return key.map((currentKey) => get(target, currentKey)).filter((a) => a).join('::');
  }

  return target as unknown as string;
}
